<!--  -->
<template>
  <div class="container">
    <img src="../../assets/images/device-mupli.png" alt="多体征许可证" v-if="pageType == 1">
    <img src="../../assets/images/device-fetal.png" alt="胎监许可证" v-if="pageType == 2">
    <img src="../../assets/images/device-super-fetal.png" alt="超音胎音仪许可证" v-if="pageType == 3">
    <img src="../../assets/images/medical_device_license.png" alt="医疗器械经营备案凭证" v-if="pageType == 4">
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        pageType: 1
      }
    },

    props: [],

    watch: {},

    components: {},

    computed: {},

    created() {
      console.log(this.$route)
      if (this.$route.query.pageType) {
        this.pageType = this.$route.query.pageType
      }
    },

    methods: {}
  }

</script>
<style lang='scss' scoped>
  .container {
    padding-top: 30px;

    img {}
  }

</style>



// WEBPACK FOOTER //
// src/pages/deviceLicense/deviceLicense.vue